import React, { useEffect, useState } from 'react';
import ssomaService from '../services/ssomaService';

const TALLAS_PANTALON = ['26', '28', '30', '32', '34', '36', '38', '40', '42', '44'];
const TALLAS_POLO = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
const TALLAS_ZAPATO = ['35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46'];

const VACIO = {
  talla_pantalon: '',
  talla_polo: '',
  talla_zapatos: '',
  observaciones: '',
};

const SsomaTallasTab = ({ empresaId, empleadoId, compacto = false, soloLectura = false }) => {
  const [form, setForm] = useState(VACIO);
  const [cargando, setCargando] = useState(false);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState('');
  const [mensaje, setMensaje] = useState('');

  useEffect(() => {
    const cargar = async () => {
      if (!empresaId || !empleadoId) return;
      setCargando(true);
      setError('');
      const response = await ssomaService.obtenerTallas(empresaId, empleadoId);
      if (response.success) {
        setForm({
          talla_pantalon: response.data?.talla_pantalon || '',
          talla_polo: response.data?.talla_polo || '',
          talla_zapatos: response.data?.talla_zapatos || '',
          observaciones: response.data?.observaciones || '',
        });
      } else {
        setError(response.error || 'No se pudieron cargar las tallas');
      }
      setCargando(false);
    };
    cargar();
  }, [empresaId, empleadoId]);

  const guardar = async (e) => {
    e.preventDefault();
    if (soloLectura || !empresaId || !empleadoId) return;
    setGuardando(true);
    setError('');
    setMensaje('');
    const response = await ssomaService.guardarTallas(empresaId, empleadoId, form);
    if (response.success) {
      setMensaje('Tallas guardadas');
      setTimeout(() => setMensaje(''), 3000);
    } else {
      setError(response.error || 'No se pudieron guardar las tallas');
    }
    setGuardando(false);
  };

  if (!empleadoId) {
    return (
      <div className="bg-amber-50 border border-amber-200 rounded-lg p-6 text-amber-800">
        Guarda el empleado primero para registrar las tallas SSOMA.
      </div>
    );
  }

  if (cargando) {
    return <p className="text-sm text-gray-500">Cargando tallas...</p>;
  }

  return (
    <form onSubmit={guardar} className="space-y-4">
      {!compacto && !soloLectura && (
        <p className="text-sm text-gray-600">
          Registra la talla de pantalón, polo y zapatos para que el área SSOMA las consulte al
          entregar EPP y uniforme.
        </p>
      )}
      {soloLectura && (
        <p className="text-xs text-gray-500">
          Solo consulta. Las tallas se registran en la ficha del empleado.
        </p>
      )}

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm">{error}</div>
      )}
      {mensaje && (
        <div className="bg-green-50 border border-green-200 text-green-700 rounded-lg p-3 text-sm">{mensaje}</div>
      )}

      <div className={`grid grid-cols-1 ${compacto ? 'sm:grid-cols-3' : 'md:grid-cols-3'} gap-4`}>
        <label className="block">
          <span className="block text-sm font-medium text-gray-700 mb-1">Talla de pantalón</span>
          <input
            list="tallas-pantalon"
            value={form.talla_pantalon}
            onChange={(e) => setForm({ ...form, talla_pantalon: e.target.value })}
            readOnly={soloLectura}
            className={`w-full border rounded-lg px-3 py-2 text-sm ${soloLectura ? 'border-gray-200 bg-gray-50 text-gray-700' : 'border-gray-300'}`}
            placeholder={soloLectura ? 'Sin registrar' : 'Ej. 32'}
          />
          <datalist id="tallas-pantalon">
            {TALLAS_PANTALON.map((talla) => (
              <option key={talla} value={talla} />
            ))}
          </datalist>
        </label>
        <label className="block">
          <span className="block text-sm font-medium text-gray-700 mb-1">Talla de polo</span>
          <input
            list="tallas-polo"
            value={form.talla_polo}
            onChange={(e) => setForm({ ...form, talla_polo: e.target.value })}
            readOnly={soloLectura}
            className={`w-full border rounded-lg px-3 py-2 text-sm ${soloLectura ? 'border-gray-200 bg-gray-50 text-gray-700' : 'border-gray-300'}`}
            placeholder={soloLectura ? 'Sin registrar' : 'Ej. M'}
          />
          <datalist id="tallas-polo">
            {TALLAS_POLO.map((talla) => (
              <option key={talla} value={talla} />
            ))}
          </datalist>
        </label>
        <label className="block">
          <span className="block text-sm font-medium text-gray-700 mb-1">Talla de zapatos</span>
          <input
            list="tallas-zapatos"
            value={form.talla_zapatos}
            onChange={(e) => setForm({ ...form, talla_zapatos: e.target.value })}
            readOnly={soloLectura}
            className={`w-full border rounded-lg px-3 py-2 text-sm ${soloLectura ? 'border-gray-200 bg-gray-50 text-gray-700' : 'border-gray-300'}`}
            placeholder={soloLectura ? 'Sin registrar' : 'Ej. 42'}
          />
          <datalist id="tallas-zapatos">
            {TALLAS_ZAPATO.map((talla) => (
              <option key={talla} value={talla} />
            ))}
          </datalist>
        </label>
      </div>

      <label className="block">
        <span className="block text-sm font-medium text-gray-700 mb-1">Observaciones</span>
        <textarea
          value={form.observaciones}
          onChange={(e) => setForm({ ...form, observaciones: e.target.value })}
          rows={compacto ? 2 : 3}
          readOnly={soloLectura}
          className={`w-full border rounded-lg px-3 py-2 text-sm ${soloLectura ? 'border-gray-200 bg-gray-50 text-gray-700' : 'border-gray-300'}`}
          placeholder={soloLectura ? 'Sin observaciones' : 'Otras medidas o indicaciones (opcional)'}
        />
      </label>

      {!soloLectura && (
      <button
        type="submit"
        disabled={guardando}
        className="px-4 py-2 bg-teal-600 text-white text-sm font-medium rounded-lg hover:bg-teal-700 disabled:bg-gray-400"
      >
        {guardando ? 'Guardando…' : 'Guardar tallas'}
      </button>
      )}
    </form>
  );
};

export default SsomaTallasTab;
